import { useQuery, useSuspenseQuery } from "@apollo/client";
import { AppContextContext } from "../context";
import { useContext } from "react";
export default (query, options) => {
  const appContext = useContext(AppContextContext);
  return appContext?.useSuspense && options?.ssr ? useSuspenseQuery(query, options) : useQuery(query, options);
};